import {
  TourService,
  ShippingService
} from '@/services/api'

export default {
  data() {
    return {
      tourCommissionPercentage: null,
      takeCheckConfig: {},
      updating: false
    }
  },
  methods: {
    setTourAsWaiting(tour, silent = false) {
      if (!silent) {
        if (
          confirm('Are you sure you want to set this tour as WAITING?')
        ) {
          this.$http.post(this.$appConfig.api.baseUrl + 'tours/' + tour.id + '/waiting')
            .then(response => {
              if (typeof this.getTour === 'function') {
                this.getTour()
                this.$refs.modalModifyTourCommission.hide()
              } else {
                setTimeout(() => {
                  this.$root.$emit('bv::refresh::table', 'my-table')
                }, 200)
              }
            })
        }
      } else {
        this.$http.post(this.$appConfig.api.baseUrl + 'tours/' + tour.id + '/waiting')
          .then(response => {
            if (typeof this.getTour === 'function') {
              this.getTour()
              this.$refs.modalModifyTourCommission.hide()
            } else {
              setTimeout(() => {
                this.$root.$emit('bv::refresh::table', 'my-table')
              }, 200)
            }
          })
      }
    },
    deleteFromTour(tour, shipping, deleteType = 'A', silent = false) {
      if (tour && shipping) {
        if (!silent) {
          if (
            confirm(this.$gettext('Are you sure you want to DELETE this shipping from the current Tour?'))
          ) {
            this.doDeleteFromTour(tour, shipping, deleteType)
          }
        } else {
          this.doDeleteFromTour(tour, shipping, deleteType)
        }
      }
    },
    doDeleteFromTour(tour, shipping, deleteType = 'A') {
      let params
      if (deleteType === 'A') {
        params = {
          shipping_id: shipping.id,
          user_id: this.profile.id,
          status: 'READY'
        }
      } else if (deleteType === 'B' && shipping.status !== 'CONFIRMED') {
        params = {
          shipping_id: shipping.id,
          user_id: this.profile.id,
          status: 'WAITING'
        }
      } else if (deleteType === 'B' && shipping.status === 'CONFIRMED') {
        params = {
          shipping_id: shipping.id,
          user_id: this.profile.id,
          status: 'READY'
        }
        ShippingService.changeStatus(params)
          .then(response => {
            params = {
              shipping_id: shipping.id,
              user_id: this.profile.id,
              status: 'WAITING'
            }
            ShippingService.changeStatus(params)
              .then(response => {
                TourService.removeShippings(tour.id, { body: [shipping.id] })
                  .then(response => {
                    this.$emit('tour-updated', true)
                    if (this.tour) {
                      this.getTour()
                      this.$refs.tourMap.fetchTours()
                    } else {
                      this.$parent.refreshTable()
                      this.$refs.modalTourMap.hide()
                    }
                  })
              })
          })
        return true
      }

      ShippingService.changeStatus(params)
        .then(response => {
          TourService.removeShippings(tour.id, { body: [shipping.id] })
            .then(response => {
              this.$emit('tour-updated', true)
              if (this.tour) {
                this.getTour()
              } else {
                this.$parent.refreshTable()
                this.$refs.modalTourMap.hide()
              }
            })
        })
    },
    formatNumber(number) {
      return (Math.round(((Number.parseFloat(number)) + Number.EPSILON) * 100) / 100).toFixed(2)
    },
    priceByKm(tour) {
      const currency = window.countries.find(x => x.iso_code === tour.country_iso_code).currency
      const priceByKm = this.formatNumber((Number.parseFloat(tour.commission / tour.total_distance)))

      if (tour.commission && tour.total_distance) {
        return `<span style="white-space: nowrap">${priceByKm} ${currency}/km.</span><br>`
      }
    },
    getTake(price, commission) {
      return this.formatNumber(((Number.parseFloat(price) - Number.parseFloat(commission)) * 100 / Number.parseFloat(price)))
    },
    sanityDetail(tour) {
      const currency = window.countries.find(x => x.iso_code === tour.country_iso_code).currency

      const courierProfit = this.formatNumber(tour.commission)

      const clientCost = this.formatNumber(tour.price)

      const ourProfit = this.formatNumber((Number.parseFloat(tour.price) - Number.parseFloat(tour.commission)))

      const take = this.getTake(tour.price, tour.commission)

      let html = ''
      if (tour.fixed_amount_price_schedules.length === 0) {
        html += `<span style="white-space: nowrap">Courier profit: ${courierProfit} ${currency}</span><br>`
      }
      let takeClass = 'text-danger'
      if (take >= 30) {
        takeClass = 'text-success'
      } else if (take < 30 && take > 0) {
        takeClass = 'text-warning'
      }
      html += `
      <span style="white-space: nowrap">Client cost: ${clientCost} ${currency}</span><br>
      <span class="${takeClass}">Our profit: ${ourProfit} ${currency}</span><br>
      <span class="${takeClass}">Take: ${take}%</span><br>`
      html += this.priceByKm(tour) // + <span style="white-space: nowrap">${currency}/km.: ${priceByKm} ${currency}/km.</span><br>

      return html
    },
    async takeCheck(type, tour = null) {
      this.takeCheckConfig = {}
      if (!tour) {
        tour = this.tour
      }

      let tourRegionId

      const tourCountryTakeCheckConfig = window.countries.find(x => x.iso_code === tour.country_iso_code).front_config.takeCheckConfig

      if (tourCountryTakeCheckConfig) {
        if (!tour.shippings) {
          tour.shippings = await this.getTourShippings(tour)
        }
        tourRegionId = tour.shippings[0].to_area.regions.length > 0 ? tour.shippings[0].to_area.regions[0].id : null
        this.takeCheckConfig = tourCountryTakeCheckConfig.find(x => x.region_id === tourRegionId)
      }

      if (this.takeCheckConfig?.region_id) {
        const shippingsCount = tour.shippings.length

        if (this.takeCheckConfig.tour_quantity_check && (shippingsCount < this.takeCheckConfig.tour_min_quantity || shippingsCount > this.takeCheckConfig.tour_max_quantity)) {
          const goOnButtonText = type === 'assign' ? this.$gettext('Assignate it anyway') : this.$gettext('Set as WAITING anyway')
          const obj = {
            title: this.$gettext('Shipping Quantity Alert'),
            message: this.$gettextInterpolate(
              this.$gettext('This tour has %{count} shippings and it DOES NOT match the recommended shippings quantity which is between %{min} and %{max}'),
              {
                count: shippingsCount,
                min: this.takeCheckConfig.tour_min_quantity,
                max: this.takeCheckConfig.tour_max_quantity
              }
            ),
            type: 'warning',
            useConfirmBtn: true,
            customConfirmBtnText: goOnButtonText,
            onConfirm: () => {
              this.takeCheckCommission(type, tour)
            }
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        } else {
          this.takeCheckCommission(type, tour)
        }
      } else if (type === 'assign') {
        this.$refs.modalAssignNormal.show()
      } else if (type === 'waiting') {
        this.setTourAsWaiting(tour)
      }
    },
    takeCheckCommission(type, tour = null) {
      if (!tour) {
        tour = this.tour
      }
      const tourData = this.takeCheckCurrentData(tour)
      if (
        tourData.takeDiff !== 0 &&
        (this.takeCheckConfig.tour_allow_negative_impact === true || (this.takeCheckConfig.tour_allow_negative_impact === false && tourData.takeDiff > 0))
      ) {
        const fixItButtonText = type === 'assign' ? this.$gettext('FIX IT and assign') : this.$gettext('FIX IT and set as WAITING')
        const goOnNormallyButtonText = type === 'assign' ? this.$gettext('Assign it AS IS') : this.$gettext('Set as WAITING AS IS')

        let mssg = ''
        if (tourData.optimalCommission > tourData.price) {
          mssg += '<p class="text-danger"><strong>' + this.$gettext('WARNING: THE OPTIMAL TOUR COMMISSION IS HIGHER THAN THE CLIENT COST!!!') + '</strong></p>'
        }
        mssg += '<p>' + this.$gettextInterpolate(this.$gettext('Current commission: <strong>%{commission}</strong>'), { commission: this.formatNumber(tourData.commission) }) + '<br>'
        mssg += this.$gettextInterpolate(this.$gettext('Optimal tour commission: <strong>%{optimalCommission}</strong>'), { optimalCommission: this.formatNumber(tourData.optimalCommission) }) + '<br>'
        mssg += this.$gettextInterpolate(this.$gettext('Current take: <strong>%{take}%</strong>'), { take: this.formatNumber(tourData.take) }) + '<br>'
        mssg += this.$gettextInterpolate(this.$gettext('Optimal tour take: <strong>%{optimalTake}%</strong>'), { optimalTake: this.formatNumber(tourData.optimalTake) }) + '</p>'
        mssg += '<p class="' + (tourData.takeDiff < 0 ? 'text-danger' : 'text-success') + '">' + this.$gettextInterpolate(
          this.$gettext('Fixing this tour would make our take <strong>%{betterWorse}</strong> by %{takeDiff}%'),
          {
            betterWorse: tourData.takeDiff < 0 ? this.$gettext('worse') : this.$gettext('better'),
            takeDiff: this.formatNumber(tourData.takeDiff)
          }
        ) + '</p>'
        const obj = {
          title: this.$gettext('Commission Alert'),
          message: mssg,
          type: 'warning',
          useConfirmBtn: true,
          customConfirmBtnText: fixItButtonText,
          customConfirmBtnClass: 'btn btn-primary btn-block',
          onConfirm: () => {
            this.updating = true
            this.fixCommissions(type, tourData.optimalPercent, tour)
          },
          customCloseBtnText: goOnNormallyButtonText,
          customCloseBtnClass: 'btn btn-secondary btn-block',
          onClose: () => {
            if (type === 'assign') {
              this.$refs.modalAssignNormal.show()
            } else if (type === 'waiting') {
              this.setTourAsWaiting(tour, true)
            }
          }
        }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
      } else if (type === 'assign') {
        this.$refs.modalAssignNormal.show()
      } else if (type === 'waiting') {
        this.setTourAsWaiting(tour)
      }
    },
    async fixCommissions(type, optimalPercent, tour = null) {
      if (!tour) {
        tour = this.tour
      }
      if (optimalPercent >= -100) {
        this.tourCommissionPercentage = optimalPercent
        await this.modifyTourCommission(true, tour)
          .then(() => {
            if (type === 'assign') {
              this.$refs.modalAssignNormal.show()
            } else if (type === 'waiting') {
              this.setTourAsWaiting(tour, true)
            }
          })
          .finally(() => {
            this.tourCommissionPercentage = null
            this.updating = false
          })
      }
    },
    takeCheckCurrentData(tour) {
      const price = tour.price
      const commission = tour.commission
      const shippingsCount = tour.shippings.length
      const tourDistance = tour.total_distance
      const take = this.getTake(price, commission)

      const optimalCommissionKm = this.takeCheckConfig.tour_min_price_km * tourDistance
      const optimalCommissionShipping = this.takeCheckConfig.tour_min_price * shippingsCount
      const optimalCommission = Math.max(optimalCommissionKm, optimalCommissionShipping)
      const optimalTake = this.getTake(price, optimalCommission)
      const optimalPercent = -(100 - optimalCommission * 100 / commission)
      const takeDiff = optimalTake - take
      return {
        price,
        commission,
        shippingsCount,
        tourDistance,
        take,
        optimalCommission,
        optimalTake,
        optimalPercent,
        takeDiff
      }
    },
    async getTourShippings(tour) {
      const params = {
        includes: [
          'shippings.to_area.regions'
        ]
      }
      return await this.$http.get(this.$appConfig.api.baseUrl + 'tours/' + tour.id, { params })
        .then(response => {
          return response.body.shippings
        })
    },
    async modifyTourCommission(silent = false, tour = null) {
      if (!tour) {
        tour = this.tour
      }
      if (!silent) {
        if (
          confirm('Are you sure you want to MODIFY the total Tour Commission by your set percentage?')
        ) {
          return await this.$http.put(this.$appConfig.api.baseUrl + 'tours/' + tour.id + '/commission', { percentage: this.tourCommissionPercentage })
            .then(response => {
              if (typeof this.getTour === 'function') {
                this.getTour()
                this.$refs.modalModifyTourCommission.hide()
              } else {
                this.$parent.refreshTable()
              }
            })
        }
      } else {
        return await this.$http.put(this.$appConfig.api.baseUrl + 'tours/' + tour.id + '/commission', { percentage: this.tourCommissionPercentage })
          .then(response => {
            if (typeof this.getTour === 'function') {
              this.getTour()
              this.$refs.modalModifyTourCommission.hide()
            }
          })
      }
    },
    downloadToursCsv() {
      const filename = this.moment().format('YYYY-MM-DD_HH:mm:ss') + '__exported_tours.csv'

      const params = {
        format: 'csv',
        ids: []
      }
      for (const item of this.selected) {
        params.ids.push(item.id)
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'tours/list', { params })
        .then(response => {
          const blob = new Blob([response.body], { type: 'text/csv;charset=utf-8;' })
          if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename)
          } else {
            const link = document.createElement('a')
            if (link.download !== undefined) { // feature detection
              // Browsers that support HTML5 download attribute
              const url = URL.createObjectURL(blob)
              link.setAttribute('href', url)
              link.setAttribute('download', filename)
              link.style.visibility = 'hidden'
              document.body.appendChild(link)
              link.click()
              link.remove()
            }
          }
        })
    },
    realVisits(item) {
      const visits4Show = []
      let prevVisit
      let notOptimized
      let pickups = 0
      let dropoffs = 0

      for (const visit of item.visits) {
        this.notOptimized = this.notOptimized === true || visit.order === null || false
        visit.status = item.status
        visit.multi = item.multi
        if (visit.type + '-' + visit.place_id !== prevVisit) {
          visit.shipping_ids = [visit.shipping_id]
          visits4Show.push(visit)
          if (visit.type === 'pickup') {
            pickups++
          } else {
            dropoffs++
          }
        } else {
          if (visit.visited === 1) {
            visits4Show.at(-1).visited = 1
          }
          visits4Show.at(-1).shipping_ids.push(visit.shipping_id)
        }
        prevVisit = visit.type + '-' + visit.place_id
      }

      item.pickups = pickups
      item.dropoffs = dropoffs
      item.visits4Show = visits4Show
      item.notOptimized = notOptimized
      return item
    }
  }
}
